import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { getReportSignStatus, reportsModel } from '@/entities/reports';

export const useFDA3DGPDownloadRestriction = (reportID: string) => {
  const { isFDA3DGPRestrictions } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const report = useAppSelector(reportsModel.selectors.selectByID(reportID));

  const isGPReport = report?.Type === ReportType.ReportType_CBCT_GP;
  const isReportSigned = getReportSignStatus(report) === 'signed';

  return isFDA3DGPRestrictions && isGPReport && !isReportSigned;
};
